import {
    JsonItem
} from "../../../shared/entities/pick-list/pick-list.entities";

import {
    EditTable,
    EditTableConfig,
    EditTableSortColumn,
    IEditController
} from "../../../shared/components/edit-table/edit-table";


function customizeAccessTableHeader(
    tableId: string
): void {

    const $wrapper =
        $(`#${tableId}_wrapper`);

    const $topControls =
        $wrapper.find(
            `.${tableId}-top-controls`
        );

    const $search =
        $topControls
            .find(
                `.${tableId}-search-bar`
            )
            .detach();

    const $buttons =
        $topControls
            .find(
                ".dt-buttons"
            )
            .detach();

    const $count =
        $(
            `#${tableId}-table-count-found`
        )
            .detach();

    $search
        .removeClass(
            "col-12 col-md-3"
        )
        .addClass(
            "mr-auto"
        );

    $buttons
        .removeClass(
            "btn-group flex-wrap"
        )
        .addClass(
            "d-flex align-items-center"
        );

    $count
        .removeClass(
            "pr-3"
        )
        .addClass(
            "mr-3 nowrap"
        );

    const $actions =
        $(`
            <div class="
                d-flex
                align-items-center
                justify-content-end
                ml-auto
                flex-shrink-0
            ">
            </div>
        `);

    $actions.append(
        $count,
        $buttons
    );

    $topControls
        .removeClass(
            "row mx-0 align-items-center"
        )
        .addClass(
            "d-flex " +
            "align-items-center " +
            "justify-content-between " +
            "w-100 mb-1"
        )
        .empty()

        .append(
            $search,
            $actions
    );
    const dataTable =
        $(`#${tableId}`)
            .DataTable();

    const updateCount =
        (): void => {

            const filteredCount =
                dataTable
                    .rows({
                        search:
                            "applied"
                    })
                    .count();

            $count.text(
                filteredCount === 1
                    ? "1 User"
                    : `${filteredCount} Users`
            );
        };

    dataTable
        .off(
            "search.dt.cabHubCount " +
            "draw.dt.cabHubCount"
        )
        .on(
            "search.dt.cabHubCount " +
            "draw.dt.cabHubCount",
            updateCount
        );

    updateCount();

    $(
        `#${tableId}-filter-tab-container`
    ).remove();

    $(
        `#${tableId}-filter-container`
    ).remove();

    $(
        `#${tableId}-target-container`
    )
        .children("hr")
        .remove();
}

export type CabHubAccessEntity = {
    UserId: number;

    Name: string;

    Email: string;

    Roles: string[];

    RoleDisplay: string;

    HubId: number | null;

    HubDisplay: string;

    HasHubPermission: boolean;

    HubAccessDisplay: string;
};

export class CabHubRoleTable {
    public tableConfig:
        EditTableConfig;

    public editTable:
        EditTable;

    private roleList:
        CabHubAccessEntity[];

    private pickLists:
        JsonItem[];

    constructor(
        private readonly targetId:
            string,

        private readonly users:
            CabHubAccessEntity[],

       
        editController:
            IEditController,

    ) {
        this.pickLists = [];

        this.tableConfig = {
            tableId:
                "cab-hub-role-table",

            tableVarName:
                "roleTable.editTable",

            propertyIdName:
                "UserId",

            itemDisplayName:
                "Users",

            isEditable:
                true,

            isMultiselect:
                false,

            editController:
                editController,

            tableColumnGroups: [],

            filterTabs: [],

            columns: [
                {
                    data:
                        "Name",

                    title:
                        "Name",

                    className:
                        "general text-left " +
                        "font-size12"
                },
                {
                    data:
                        "Email",

                    title:
                        "Email",

                    className:
                        "general text-left " +
                        "font-size12"
                },
                {
                    data:
                        "RoleDisplay",

                    title:
                        "User Roles",

                    className:
                        "general text-left " +
                        "font-size12",

                    render:
                        (
                            data:
                                string
                        ): string => {

                            return data ||
                                "—";
                        }
                },
                {
                    data:
                        "HubDisplay",

                    title:
                        "Hub",

                    className:
                        "general text-left " +
                        "font-size12",

                    render:
                        (
                            data:
                                string
                        ): string => {

                            return data ||
                                "—";
                        }
                }
            ],

            sortOrder: [
                new EditTableSortColumn(
                    0,
                    "asc"
                )
            ]
        };

        this.editTable =
            new EditTable(
                this.tableConfig
            );
    }

    public initialize():
        void {

        const html =
            this.editTable
                .generateHtml();

        $(`#${this.targetId}`)
            .empty()
            .html(
                html
            );

        this.roleList =
            this.users ?? [];

        this.editTable.initialize(
            this.roleList,
            this.pickLists
        );

     
        customizeAccessTableHeader(
            this.tableConfig.tableId
        );
        setTimeout(
            () =>
                this.editTable
                    .resizeTable(),
            100
        );
    }

    public resize():
        void {

        this.editTable
            .resizeTable();
    }
    public refresh():
        void {

        this.roleList =
            [...(this.users ?? [])];

        this.editTable
            .updateTable(
                this.roleList
            );
    }
   
 
}


export class CabHubPermissionTable {
    public tableConfig:
        EditTableConfig;

    public editTable:
        EditTable;

    private permissionList:
        CabHubAccessEntity[];

    private readonly pickLists:
        JsonItem[] = [];

    constructor(
        private readonly targetId:
            string,

        private readonly users:
            CabHubAccessEntity[],

        editController:
            IEditController,

        private readonly onAddPermission:
            () => void

      
    ) {
        this.tableConfig = {
            tableId:
                "cab-hub-permission-table",

            tableVarName:
                "permissionTable.editTable",

            propertyIdName:
                "UserId",

            itemDisplayName:
                "Users",

            isEditable:
                true,

            isMultiselect:
                false,

            editController:
                editController,

            tableColumnGroups: [],

            filterTabs: [],

            columns: [
                {
                    data:
                        "Name",

                    title:
                        "Name",

                    className:
                        "general text-left " +
                        "font-size12"
                },
                {
                    data:
                        "Email",

                    title:
                        "Email",

                    className:
                        "general text-left " +
                        "font-size12"
                },
                {
                    data:
                        "HubAccessDisplay",

                    title:
                        "Hub Access",

                    className:
                        "general text-left " +
                        "font-size12",

                    render:
                        (
                            data:
                                string
                        ): string => {

                            return data ||
                                "—";
                        }
                }
            ],

            sortOrder: [
                new EditTableSortColumn(
                    0,
                    "asc"
                )
            ]
        };

        this.editTable =
            new EditTable(
                this.tableConfig
            );
    }

    public initialize():
        void {

        const html =
            this.editTable
                .generateHtml();

        $(`#${this.targetId}`)
            .empty()
            .html(
                html
            );

        this.permissionList =
            (this.users ?? [])
                .filter(
                    user =>
                        user.HasHubPermission
                );

        this.editTable.initialize(
            this.permissionList,
            this.pickLists
        );

        this.initializeAddButton();
        customizeAccessTableHeader(
            this.tableConfig.tableId
        );

        setTimeout(
            () =>
                this.editTable
                    .resizeTable(),
            100
        );
    }

    public refresh():
        void {

        this.permissionList =
            [...(this.users ?? [])]
                .filter(
                    user =>
                        user.HasHubPermission
                );

        this.editTable
            .updateTable(
                this.permissionList
            );
    }
    public resize():
        void {

        this.editTable
            .resizeTable();
    }

    private initializeAddButton():
        void {

        const buttonId =
            `${this.tableConfig.tableId}-add-permission`;

        const $buttonContainer =
            $(
                `#${this.tableConfig.tableId}_wrapper`
            )
                .find(
                    ".dt-buttons"
                );

        $(`#${buttonId}`)
            .remove();

        const $addButton =
            $(`
                <button type="button"
                        id="${buttonId}"
                        class="
                            btn
                            btn-sm
                          
                            no-focus
                            font-size12
                            add-btn
                            mr-2 nowrap
                        ">
                    <i class="fas fa-plus mr-1"></i>
                    Add Permission
                </button>
            `);

        $addButton
            .off(
                "click.cabHubPermission"
            )
            .on(
                "click.cabHubPermission",
                () => {

                    this.onAddPermission();
                }
            );

        $buttonContainer
            .prepend(
                $addButton
            );
    }
}